import NewListConnector from './newList.props';
import NewListComponent from './newList.component';

export default NewListConnector(NewListComponent);
